import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { REPORT_BASE_PATH, REPORT_PERFORMANCE_PATH, REPORT_PERFORMANCE_PRODUCTION_TARGET_PATH } from '../../../../constants';
import { ReportType } from '../../../../types/report-types';
import { useIntl } from 'react-intl';
import { createNewProductionTargetReport } from '../../../../network/reportCrud';
import CreateReport from '../../../../components/CreateReport';

const ProductionReportPage: FC<RouteComponentProps> = ({ history, location }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  
  return (
    <CreateReport
      title={Translation("productionTarget.title")}
      reportType={ReportType.PRODUCTION_TARGET}
      onCreate={createNewProductionTargetReport}
      onBack={() => history.push(`${REPORT_BASE_PATH}${REPORT_PERFORMANCE_PATH}${REPORT_PERFORMANCE_PRODUCTION_TARGET_PATH}`)}
      fields={[{
        name: "year",
        displayText: Translation("productionTarget.common.year"),
        type: "date-year",
        mandatory: true
      }]}
    />
  )
};

export default ProductionReportPage;
